export const lazyImageAttr = '[data-lazy-image]'
export const swiperAttr = '[data-swiper]'
export const startedClass = 'started'
export const loadingClass = 'loading'
export const loadedClass = 'loaded'
export const hiddenClass = 'hidden'
export const filterOpenedClass = 'filter-opened'
export const cssAnimationAttr = '[data-css-animation]'
export const header = document.querySelector('.header')
export const footer = document.querySelector('.footer')
export const preloader = document.querySelector('.preloader')
export const preloaderLogo = preloader.querySelector('.preloader__logo')
export const preloaderGreenBlock = preloader.querySelector('.preloader__green')
export const preloaderBlackBlock = preloader.querySelector('.preloader__black')
export const headerBrandClass = 'header__brand'
export const pswp = document.querySelector('.pswp')
export const bgColorSection = document.querySelector('[data-bg-color-section]')
export const textDecoration = document.querySelector('[data-decoration-text]')
export const bgChangeSection = document.querySelector(
  '[data-bg-change-section]'
)
export const menu = document.querySelector('.menu')
